var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447.8 249.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #98c49d;\n      }\n\n      .st1 {\n        fill: #4a4590;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,139.5h87.5c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5H23.5C10.5,186.5,0,176,0,163s10.5-23.5,23.5-23.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,236.5l58.9-161.9c6.1-16.8,26.8-16.8,32.9,0l58.9,161.9c2.8,7.6,9.3,12.6,16.4,12.6h9.9c12.8,0,21.4-15,16.4-28.5L158.2,29.4C151.6,11.6,136.4,0,119.5,0h0c-16.9,0-32.1,11.6-38.7,29.4L1.4,220.6c-5,13.5,3.6,28.5,16.4,28.5h9.9c7.2,0,13.7-5,16.4-12.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.2,109.6h-87.5c-13,0-23.5-10.5-23.5-23.5s10.5-23.5,23.5-23.5h87.5c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.6,12.6l-58.9,161.9c-6.1,16.8-26.8,16.8-32.9,0L252.9,12.6C250.1,5,243.7,0,236.5,0h-9.9c-12.8,0-21.4,15-16.4,28.5l79.4,191.2c6.6,17.8,21.8,29.4,38.7,29.4h0c16.9,0,32.1-11.6,38.7-29.4L446.3,28.5C451.3,15,442.7,0,429.9,0h-9.9c-7.2,0-13.7,5-16.4,12.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75555ad774b3b0654480113dff0da365.svg";
export { ForwardRef as ReactComponent };